import HttpClient from "@/utils/HttpClient";
import R from "@/utils/r";
import {ElMessage} from "element-plus";

abstract class BaseService {
    private httpClient: HttpClient;

    constructor() {
        // 创建一个 HttpClient 实例，指定基础的 API 地址
        this.httpClient = new HttpClient(process.env.VUE_APP_API_URL);
    }

    public async postFetchData(url: string, form: any = {}): Promise<any> {
        form = this.objectToFormData(form);
        // 发送 POST 请求
        return await this.httpClient.post(url, form)
            .then((data: any) => {
                R.precheck(data)
                return data;
            })
            .catch(error => {
                ElMessage({
                    showClose: true,
                    message: error.message,
                    type: 'error',
                })
                console.error('请求失败：', error);
            });
    }

    public async getFetchData(url: string, query: any): Promise<any> {
        url = url + "?" + this.objectToQueryString(query);
        // 发送 POST 请求
        return await this.httpClient.get(url)
            .then((data: any) => {
                R.precheck(data)
                return data;
            })
            .catch(error => {
                ElMessage({
                    showClose: true,
                    message: error.message,
                    type: 'error',
                })
                console.error('请求失败：', error);
            });
    }


    public async getFetchDataNoCheck(url: string, query: any): Promise<any> {
        url = url + "?" + this.objectToQueryString(query);
        // 发送 POST 请求
        return await this.httpClient.get(url)
            .then((data: any) => {
                return data;
            })
            .catch(error => {
                console.error('请求失败：', error);
            });
    }



    public objectToQueryString(obj: { [key: string]: any }): string {
        return Object.keys(obj)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
            .join('&');
    }

    public objectToFormData(obj: { [key: string]: any }): FormData {
        const formData = new FormData();
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                formData.append(key, obj[key]);
            }
        }
        return formData;
    }


}

export default BaseService;
